module.exports = __webpack_public_path__ + "img/zihangche.76d75fe4.png";